const sortByTeamName = (a, b) => a.teamName.toLowerCase().localeCompare(b.teamName.toLowerCase());

const getChildren = (list, id) => {
	if (id) return list.filter(({parentComponentId}) => parentComponentId === id).sort(sortByTeamName);
	return list
		.filter(({parentComponentId = null}) => !list.some((t) => t.gaComponentId === parentComponentId))
		.sort(sortByTeamName);
};

const hasChildren = (list, id) => getChildren(list, id).length !== 0;

const assignChildren = (list, id = null) => {
	const children = getChildren(list, id);
	if (children.length !== 0) {
		return [...children].map((team) =>
			hasChildren(list, team.gaComponentId) ? {...team, children: assignChildren(list, team.gaComponentId)} : {...team}
		);
	}
	return [...children];
};

export default (teams) => {
	return assignChildren(teams);
};
